export function billingErrorCode(error) {
	return error?.response?.data?.error?.code || error?.code || null
}

// The offers endpoint itself is the current V1 capability check. Newer
// server contracts may expose an explicit flag, which always takes priority.
export function canPurchaseFromCatalog(catalog) {
	if (!catalog || typeof catalog !== 'object') return false
	if (typeof catalog.canPurchase === 'boolean') return catalog.canPurchase
	if (typeof catalog.canManageBilling === 'boolean') return catalog.canManageBilling
	return Array.isArray(catalog.offers)
}

export function isPurchaseUnavailable(error) {
	return billingErrorCode(error) === 'BILLING_NOT_AVAILABLE'
}
